// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"NavigationItems__NavigationItems__2aT9m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigatioItems/NavigationItems.css
// module id = 98
// module chunks = 0